import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=15218bec&scoped=true"
import script from "./Mask.vue?vue&type=script&lang=ts"
export * from "./Mask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15218bec",
  null
  
)

export default component.exports